import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface SuspensionBannerProps {
  isSuspended: boolean;
}

export const SuspensionBanner: React.FC<SuspensionBannerProps> = ({ isSuspended }) => {
  if (!isSuspended) return null;

  return (
    <aside
      role="alert"
      className="bg-rose-950/90 border-b border-rose-500/40 px-4 py-2.5 text-rose-200 text-xs sm:text-sm font-medium flex items-center justify-between shadow-lg backdrop-blur-md"
    >
      <div className="flex items-center gap-2.5 max-w-5xl mx-auto w-full">
        <AlertTriangle className="w-4 h-4 text-rose-400 shrink-0 animate-pulse" />
        <span>
          <strong>Organization Suspended:</strong> Active operations and commission payouts are
          temporarily paused. Please contact partner support to complete compliance verification.
        </span>
      </div>
    </aside>
  );
};
